import { useLocation } from 'react-router-dom';
import { Menu, Moon, Sun, ChevronRight } from 'lucide-react';
import { SheetTrigger } from '@avala/ui/components/primitives/sheet';
import { Button } from './ui';
import { currentPage } from './navigation';

export function Header({ dark, onThemeChange }: { dark: boolean; onThemeChange: () => void }) {
  const location = useLocation();
  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-3 border-b border-border px-4 sm:px-8">
      <div className="flex min-w-0 items-center gap-3">
        <SheetTrigger asChild>
          <Button variant="ghost" size="iconSm" className="lg:hidden" aria-label="Open navigation">
            <Menu />
          </Button>
        </SheetTrigger>
        <span className="hidden text-sm text-muted-foreground sm:inline">Support</span>
        <ChevronRight aria-hidden="true" className="hidden h-3 w-3 text-muted-foreground sm:block" />
        <span className="truncate text-sm">{currentPage(location.pathname)}</span>
      </div>
      <Button
        variant="ghost"
        size="iconSm"
        aria-label={dark ? 'Use light appearance' : 'Use dark appearance'}
        onClick={onThemeChange}
      >
        {dark ? <Sun /> : <Moon />}
      </Button>
    </header>
  );
}
